import { Alert, AlertTitle, Container, Stack } from "@mui/material";
import type { PortalWidget } from "@entrilia/shared/api/portalWidgetsTypes";
import type { ReportInfo } from "../../../../api/types/svTypes";
import type { PortalPageStatus } from "../pages/portalPageStatusHelper";
import PortalWidgetCard from "./PortalWidgetCard";

interface Props {
  widgets: PortalWidget[];
  selectedWidgetId: string | undefined;
  onWidgetSelect: (widgetId: string) => void;
  systemReports: ReportInfo[];
  hasReportsViewPermissions: boolean;
  pageStatus: PortalPageStatus;
}

const PortalWidgetsPreviewSection = ({
  widgets,
  selectedWidgetId,
  onWidgetSelect,
  systemReports,
  hasReportsViewPermissions,
  pageStatus,
}: Props) => {
  if (widgets.length === 0) {
    return (
      <Container maxWidth="md">
        <Alert severity="warning" sx={{ mt: 2.5 }}>
          <AlertTitle>No widgets defined for the client yet</AlertTitle>
        </Alert>
      </Container>
    );
  }

  const showLiveWarning = pageStatus === "live" && !widgets.some((w) => w.status === "Live");

  return (
    <Container maxWidth="md">
      <Stack spacing={2} sx={{ pt: 2.5 }}>
        {showLiveWarning && (
          <Alert severity="warning">
            <AlertTitle>This page is Live, but no widgets are enabled.</AlertTitle>
            The page will not appear on the Investor Portal until at least one widget is turned on.
          </Alert>
        )}

        {widgets.map((widget) => (
          <PortalWidgetCard
            key={widget.id}
            widget={widget}
            selected={selectedWidgetId !== undefined && selectedWidgetId === widget.id}
            hasReportsViewPermissions={hasReportsViewPermissions}
            onSelect={onWidgetSelect}
            systemReports={systemReports}
          />
        ))}
      </Stack>
    </Container>
  );
};

export default PortalWidgetsPreviewSection;
